import type {FeatureInstance} from './feature-tree';
import {flattenChoices} from './feature-tree';
import type {FeatureProps} from './types';

type ScopeValues = Map<string, string[]>;

export class ChoiceScope {
	private readonly valuesByScope = new Map<string, ScopeValues>();
	private readonly globalValues: ScopeValues = new Map();

	constructor(features: FeatureInstance[]) {
		for (const instance of features) {
			const scopes = [instance.key, instance.owner.key];
			for (const choice of flattenChoices(instance.choices)) {
				if (choice.selected.length) this.set(scopes, choice.group.key, choice.selected);
				for (const option of choice.group.options || []) {
					if (option.props && choice.selected.includes(option.key)) this.setVariables(scopes, option.props);
				}
			}
		}
	}

	values(name: string, scopes: string[]): string[] | undefined {
		for (const scope of scopes) {
			const values = this.valuesByScope.get(scope)?.get(name);
			if (values) return values;
		}
		return this.globalValues.get(name);
	}

	private setVariables(scopes: string[], props: FeatureProps) {
		for (const [name, value] of Object.entries(props)) {
			if (typeof value === 'string') this.set(scopes, name, [value]);
		}
	}

	private set(scopes: string[], name: string, values: string[]) {
		for (const scope of scopes) {
			if (!this.valuesByScope.has(scope)) this.valuesByScope.set(scope, new Map());
			this.valuesByScope.get(scope)!.set(name, values);
		}
		if (!this.globalValues.has(name)) this.globalValues.set(name, values);
	}
}
